module.exports = __webpack_public_path__ + "img/logo.fb52ab43.png";